import { Outlet } from "react-router-dom";

import { Flexbox } from "@src/shared/components/layout/Flexbox";

import type { SettingsLayoutV2Props } from "./SettingsLayout.types";
import { SettingsSidebar } from "./SettingsSidebar";

/**
 * Two-column settings shell.
 *
 * From `md-stitch` up the shell caps itself to the height the authenticated
 * layout gives it and owns the scroll on the content column, so the settings
 * nav stays put like the authenticated sidebar does. Below `md-stitch` the nav
 * is a full-width bar tall enough to crowd out the content, so the shell stays
 * unbounded and scrolls as one page inside the layout's `main` instead.
 */
export function SettingsLayoutV2({ children }: SettingsLayoutV2Props) {
  return (
    <Flexbox className="min-h-0 w-full flex-1 flex-col md-stitch:flex-row md-stitch:overflow-hidden">
      <SettingsSidebar />
      <Flexbox className="min-w-0 flex-1 md-stitch:min-h-0 md-stitch:overflow-y-auto">
        {children ?? <Outlet />}
      </Flexbox>
    </Flexbox>
  );
}
